import { MapPin, Clock, Phone, Navigation } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { CONTACT, TOWNS } from "@/lib/site";

export default function LocalZone() {
  return (
    <section id="zone" className="border-y border-line bg-ink py-24 lg:py-32">
      <div className="mx-auto grid w-full max-w-7xl gap-12 px-5 lg:grid-cols-2 lg:px-8">
        <div>
          <SectionHead
            tag="Zone locale"
            title={<>Votre atelier <span className="text-neon">au cœur du 74</span></>}
            sub="Nous accueillons les clients de toute la vallée de l'Arve et des environs, sans rendez-vous obligatoire."
          />
          <Reveal delay={0.1}>
            <div className="mt-8 flex flex-wrap gap-2.5">
              {TOWNS.map((t) => (
                <span
                  key={t}
                  className="rounded-full border border-line bg-night px-4 py-2 text-xs font-semibold text-slate-400 transition-colors duration-200 hover:border-neon/40 hover:text-neon"
                >
                  {t}
                </span>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="flex h-full flex-col justify-between gap-8 rounded-2xl border border-neon/25 bg-gradient-to-br from-neon/10 via-transparent to-transparent p-8">
            <div className="flex items-center gap-4">
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-neon text-night chip-glow">
                <MapPin size={26} />
              </span>
              <div>
                <p className="font-display text-2xl font-extrabold uppercase tracking-tight text-white">{CONTACT.city}</p>
                <p className="text-sm text-slate-400">{CONTACT.address}</p>
              </div>
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
              <div className="rounded-xl border border-line bg-night p-5">
                <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-neon label-mono">
                  <Clock size={13} /> Horaires
                </p>
                <p className="mt-2 text-sm font-semibold text-white">{CONTACT.hours}</p>
              </div>
              <div className="rounded-xl border border-line bg-night p-5">
                <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-neon label-mono">
                  <Phone size={13} /> Direct
                </p>
                <a href={CONTACT.phoneHref} className="mt-2 block text-sm font-semibold text-white transition-colors hover:text-neon">
                  {CONTACT.phoneDisplay}
                </a>
              </div>
            </div>

            <a
              data-testid="zone-itinerary-btn"
              href={CONTACT.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 rounded-full bg-neon px-6 py-3.5 text-xs font-extrabold uppercase tracking-wider text-night chip-glow transition-transform duration-200 hover:scale-[1.02]"
            >
              <Navigation size={15} />
              Itinéraire vers l'atelier
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
